import React, { useContext } from 'react';
import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';
import ComparedCruiseTitle from 'components/ComparedCruiseTitle';
import { CompareList, CompareListItem } from './styles';

/**
 * Used on Search Results page, in 'compare mode'.
 * Shows list of cruise names selected for comparison.
 * Also displays contextual helper text while zero or one cruises (less the min needed to compare) are selected.
 */

function CompareCruisesList() {
  const { cruisesComparing, removeCruiseFromComparing } = useContext(
    CruiseSelectionContext,
  );

  return (
    <CompareList>
      {cruisesComparing.map(cruise => (
        <CompareListItem key={`compare-list-item-${cruise.id}`}>
          <ComparedCruiseTitle
            cruise={cruise}
            remove={() => removeCruiseFromComparing(cruise)}
          />
        </CompareListItem>
      ))}
    </CompareList>
  );
}

export default CompareCruisesList;
